export default {"src":"/_next/static/media/icon-tag.b7cd1a1e.svg","height":78,"width":71,"blurWidth":0,"blurHeight":0};